import { render, staticRenderFns } from "./MentorsModal.vue?vue&type=template&id=15a30d3f&scoped=true&"
import script from "./MentorsModal.vue?vue&type=script&lang=js&"
export * from "./MentorsModal.vue?vue&type=script&lang=js&"
import style0 from "./MentorsModal.vue?vue&type=style&index=0&id=15a30d3f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a30d3f",
  null
  
)

export default component.exports